<template>
  <v-virtual-scroll :items="personal" item-height="98" height="300">
    <template v-slot:default="{ item }">
      <v-list-item :key="item.idPersonal" link @click="$emit('select', item)">
        <template v-slot:default="{ active }">
          <v-list-item-avatar size="80">
            <v-img :src="item.foto" v-if="item.foto" />
            <v-icon size="48" v-else>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <div class="text-subtitle-2 font-weight-bold">{{ getFullName(item) }}</div>
            </v-list-item-title>
            <v-list-item-subtitle>
              <div>{{ item.CUIP ?? 'CUIP no asignado' }}</div>
            </v-list-item-subtitle>
            <v-list-item-subtitle> Estatus: {{ item.CatEstatus.title }} </v-list-item-subtitle>
            <v-list-item-subtitle>
              Vigencia C3:
              {{ item.vigenciaEvaluacionC3 === '' ? 'No registrado' : item.vigenciaEvaluacionC3 }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="success--text font-weight-bold">
              {{ item.portacionArma ? 'Susceptible a tercer arma' : '' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-list-item>
    </template>
  </v-virtual-scroll>
</template>

<script>
export default {
  props: {
    personal: {
      type: Array,
      required: true,
    },
  },
}
</script>
